/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiAnalyticEventFromJSON, StreemApiAnalyticEventToJSON, } from './';
export function StreemApiRecordEventsRequestFromJSON(json) {
    return StreemApiRecordEventsRequestFromJSONTyped(json, false);
}
export function StreemApiRecordEventsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'events': !exists(json, 'events') ? undefined : (json['events'].map(StreemApiAnalyticEventFromJSON)),
    };
}
export function StreemApiRecordEventsRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'events': value.events === undefined ? undefined : (value.events.map(StreemApiAnalyticEventToJSON)),
    };
}
//# sourceMappingURL=StreemApiRecordEventsRequest.js.map